import { render, staticRenderFns } from "./ClientDocList.vue?vue&type=template&id=39392c25&scoped=true&"
import script from "./ClientDocList.vue?vue&type=script&lang=js&"
export * from "./ClientDocList.vue?vue&type=script&lang=js&"
import style0 from "./ClientDocList.vue?vue&type=style&index=0&id=39392c25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39392c25",
  null
  
)

export default component.exports